module.exports = __webpack_public_path__ + "img/shipo-icon-fleet-in-port.2a1c456c.svg";